export default __webpack_public_path__ + "static/logo-1d4956762987341923215db4871e88b4.png";